import { NetworkIntegrityProviderTypes } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";

export const getDisplayProviderType = (
  providerType: string
): string => {
  switch (providerType) {
    case NetworkIntegrityProviderTypes.Network:
      return "All Network Providers";
    case NetworkIntegrityProviderTypes.Prospect:
      return "All Prospect Providers";
    case NetworkIntegrityProviderTypes.Servicing:
      return "Servicing Network Providers";
    case NetworkIntegrityProviderTypes.ProspectServicing:
      return "Servicing Prospect Providers";
    default:
      return "";
  }
};
